import React from "react";
import PropTypes from "prop-types";
import OverviewDesktop from "./OverviewDesktop";

function Overview({ app, config }) {

	return (
		<OverviewDesktop app={app} config={config} />
	);
}

Overview.defaultProps = {
	app: null,
	config: {},
};

Overview.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default Overview;
